<template>
  <v-card flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'" class="my-profile custom-my-profile">
    <v-card-actions class="pl-5 align-start py-1">
      <v-icon class="mt-4" color="#708AA7">mdi-file-document-outline</v-icon>
      <v-card-text class="px-0 py-0">
        <v-card-title>
         All agreements and T&C
        </v-card-title>
      </v-card-text>
    </v-card-actions>
    <div class="links-btn">
      <!-- Not Accepted Agreements Dialog -->
      <!-- <v-dialog transition="scale-transition" origin="center center" max-width="460" v-model="dialogNotAccepted"
        content-class="deposit-withdraw-popup">
        <template v-slot:activator="{ on, attrs }">
          <v-btn large tile outlined elevation="0" class="mx-1" color="white" v-bind="attrs" v-on="on">
            See All Not Accepted
          </v-btn>
        </template>

        <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
          <v-card-title class="pb-3 text-left justify-start pl-3">
            Not Agreed List
          </v-card-title>
          <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
            View not accepted agreements
          </v-card-subtitle>
          <v-card class="deposit-form px-3 py-4 mt-5 mb-0"
            :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
            <ul class="agreement-list">
              <li v-for="(item, index) in notAcceptedAgreements" :key="index">
                <div class="pdf-img">
                  <a class="links text-decoration-none" target="_blank" rel="noopener noreferrer"
                    :href="item.agreement_file">
                    <img class="mt-0" width="30px" alt="pdf" src="@/assets/pdf-sm.png" />
                  </a>
                  <span>{{ item.title }} </span>
                  <span v-if="item.trading_account_type" class="ml-1 small-text">({{ item.trading_account_type
                    }})</span>
                </div>
                <div class="pdf-download">
                  <a :href="item.agreement_file" class="links text-decoration-underline" target="_blank"
                    rel="noopener noreferrer" download>Download
                    <v-icon class="ml-3" small color="#039de9">
                      mdi-tray-arrow-down
                    </v-icon></a>
                </div>
              </li>
              <li v-if="notAcceptedAgreements?.length === 0" class="text-center py-3">
                No not-accepted agreements found
              </li>
            </ul>
          </v-card>
          <v-card-actions>
            <v-row dense>
              <v-col cols="12">
                <v-btn tile color="#FF567F" @click="dialogNotAccepted = false" elevation="0"
                  class="text-capitalize btn-account px-sm-8">Close</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog> -->

      <!-- Accepted Agreements Dialog -->
      <v-dialog transition="scale-transition" origin="center center" max-width="460" v-model="dialogAccepted"
        content-class="deposit-withdraw-popup">
        <template v-slot:activator="{ on, attrs }">
          <v-btn large tile elevation="0" class="mx-4" color="#039de9" v-bind="attrs" v-on="on">
            See All
          </v-btn>
        </template>

        <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
          <v-card-title class="pb-3 text-left justify-start pl-3">
            Agreement List
          </v-card-title>
          <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
            View accepted agreements
          </v-card-subtitle>
          <v-card class="deposit-form px-3 py-4 mt-5 mb-0"
            :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
            <ul class="agreement-list">
              <li v-for="(item, index) in notAcceptedAgreements" :key="index">
                <div class="pdf-img">
                  <a class="links text-decoration-none" target="_blank" rel="noopener noreferrer"
                    :href="item.agreement_file">
                    <img class="mt-0" width="30px" alt="pdf" src="@/assets/pdf-sm.png" />
                  </a>
                  <span>{{ item.title }} </span>
                  <span v-if="item.trading_account_type" class="ml-1 small-text">({{ item.trading_account_type
                    }})</span>
                </div>
                <div class="pdf-download">
                  <a :href="item.agreement_file" class="links text-decoration-underline" target="_blank"
                    rel="noopener noreferrer" download>Download
                    <v-icon class="ml-3" small color="#039de9">
                      mdi-tray-arrow-down
                    </v-icon></a>
                </div>
              </li>
            </ul>
          </v-card>
          <v-card-actions>
            <v-row dense>
              <v-col cols="12">
                <v-btn tile color="#FF567F" @click="dialogAccepted = false" elevation="0"
                  class="text-capitalize btn-account px-sm-8">Close</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { AGREEMENTS__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      dialogNotAccepted: false,
      dialogAccepted: false,
      loading: false
    };
  },
  computed: {
    ...mapState("agreements", ["acceptedAgreements", "notAcceptedAgreements"]),
  },
  methods: {
    ...mapActions("agreements", [
      AGREEMENTS__ACTIONS.ACCEPTEDAGREEMENTS,
      AGREEMENTS__ACTIONS.NOTACCEPTEDAGREEMENTS,
    ]),
  },
  async created() {
    await this[AGREEMENTS__ACTIONS.ACCEPTEDAGREEMENTS](this.$route.params.id),
      await this[AGREEMENTS__ACTIONS.NOTACCEPTEDAGREEMENTS](this.$route.params.id)
  },
};
</script>